import React from 'react';
import { Box, Typography } from '@mui/material';
import { WarningAmberRounded } from '@mui/icons-material';
import { useGlobalization } from '@Translations/useGlobalization';
import { ARTIFAKT_FONT } from './scoreGuidance';

interface Props {
	noDataPct?: number;
	countsLoaded?: boolean;
	coverageEligible?: boolean;
}

const MIN_NO_DATA_TO_WARN = 20;

export const ScoreFooter = ({
	noDataPct,
	countsLoaded,
	coverageEligible = true,
}: Props) => {
	const { t } = useGlobalization();
	if (
		!coverageEligible ||
		!countsLoaded ||
		noDataPct === undefined ||
		noDataPct < MIN_NO_DATA_TO_WARN
	) {
		return null;
	}
	return (
		<Box
			sx={{
				fontFamily: ARTIFAKT_FONT,
				display: 'flex',
				alignItems: 'flex-start',
				gap: 1,
				px: 2,
				py: 1.75,
				borderTop: '1px solid #f1f3f6',
			}}>
			<WarningAmberRounded
				sx={{ fontSize: 18, color: '#e0872f', flex: 'none', mt: '1px' }}
			/>
			<Typography
				sx={{ fontSize: 12.5, color: '#8a6d3b', lineHeight: 1.5 }}>
				{t(
					'{{miss}}% of assets have no data for this component. The score you assign to "--" drives their contribution — use the value that fits your organisation (many score unknowns higher). These assets are flagged in your model results.',
					{ miss: noDataPct },
				)}
			</Typography>
		</Box>
	);
};

export default ScoreFooter;
